import { Box } from '@mui/material';
import Expertise from './../components/expertise/expertise';
import FeaturedWork from './../components/featuredWork/featuredWork';
import FeedBackPage from './feedBackPage';
import FooterPage from './footerPage';
import HomePage from './homePage/homePage';
import NavBar from 'src/components/heroSection/navBar';
import React from 'react';
import ScrollToHash from 'src/components/scrollToHash';

const LandingPage: React.FC = () => {
    return (
        <Box display="flex" flexDirection="column" minHeight="100vh" minWidth="100%">
            <ScrollToHash />
            <NavBar />
            <HomePage />
            <Expertise />
            <FeaturedWork />
            <FeedBackPage />
            <FooterPage />
        </Box>
    );
};

export default LandingPage;
